import {ConfiguracaoBalancaComponent} from '../../equipamentos/balanca/configuracao-balanca.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DialogModule} from '@progress/kendo-angular-dialog';
import {DropDownsModule} from '@progress/kendo-angular-dropdowns';
import {NotificationModule} from '@progress/kendo-angular-notification';
import {DateInputsModule} from '@progress/kendo-angular-dateinputs';
import {CompartilhadoModule} from '../../compartilhado/compartilhado.module';
import {KitMontagemComponent} from '../../compartilhado/kit-montagem/kit-montagem.component';
import {ApplicationPipesModule} from '../../pipes/application-pipes.module';
import {TelaNovoPedidoV3Component} from './tela-novo-pedido-v3.component';
import {CentralPedidosDialogComponent} from './central-pedidos-dialog/central-pedidos-dialog.component';
import {PagamentosEletronicosPedidoModule} from '../pagamentos-eletronicos/pagamentos-eletronicos-pedido.module';

@NgModule({
  declarations: [
    TelaNovoPedidoV3Component,
    CentralPedidosDialogComponent
  ],
  imports: [
    ConfiguracaoBalancaComponent,
    CommonModule,
    FormsModule,
    DialogModule,
    DropDownsModule,
    NotificationModule,
    DateInputsModule,
    CompartilhadoModule,
    KitMontagemComponent,
    ApplicationPipesModule,
    PagamentosEletronicosPedidoModule
  ],
  exports: [
    TelaNovoPedidoV3Component
  ]
})
export class TelaNovoPedidoV3Module {
}
